module.exports = __webpack_public_path__ + "static/media/24-hours.ab239e8e.svg";